import { render, staticRenderFns } from "./dialog_assignNew.vue?vue&type=template&id=f50d208c&scoped=true&"
import script from "./dialog_assignNew.vue?vue&type=script&lang=js&"
export * from "./dialog_assignNew.vue?vue&type=script&lang=js&"
import style0 from "./dialog_assignNew.vue?vue&type=style&index=0&id=f50d208c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f50d208c",
  null
  
)

export default component.exports